/* eslint-disable no-use-before-define, no-dupe-keys, no-mixed-spaces-and-tabs, jsx-a11y/label-has-associated-control, object-shorthand */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Loading from 'components_newui/Loading';
import ModeToggle from './components/ModeToggle';
import ChallengeSelect from './components/ChallengeSelect';
import IdeaDropdownWithSearch from './components/IdeaDropdownWithSearch';
import NxtCircularLoader from 'components/nxt_circular_loader/View';
import TaggedIdeaList from './components/TaggedIdeaList';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  containerEvaluator: {
    position: 'relative'
  },
  card: {
    padding: '28px 32px',
    borderRadius: '12px',
    background: 'rgb(255, 255, 255)',
    maxWidth: '1080px',
    margin: '2rem auto',
    fontFamily: 'VodafoneRg-Regular, sans-serif',
    border: '1px solid rgb(224, 224, 224)',
    boxShadow: 'rgba(0, 0, 0, 0.08) 0px 2px 12px',
    // boxSizing: 'border-box'
  },
  cardTitle: {
    borderBottom: '2px solid rgb(230, 0, 0)',
    paddingBottom: '12px',
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'space-between'
  },
  formSection: {
    marginTop: '1.5rem',
    // display: 'flex',
    // flexDirection: 'column',
    gap: '1rem'
  },
  label: {
    margin: 0,
    fontSize: '1rem',
    color: '#333',
    marginBottom:'1rem'
  }
}));

const AdminRemoveEvaluator = (props) => {
  const classes = useStyles();
  const {
    getListIdeaListRemoveEvalutorIsLoading,
    userEmail,
    onDeteleSpecificIdeaListFromChallengeFn,
    getInnovateIdeaListFromChallenge,
    getIdeaListFromChallengeFn,
    challengesListIsLoading,
    deleteAssignedEvaluatorIntoChallengeFn,
    listInnovateChallengeForEvalutor,
    postAfterRemoveEvalutorIsLoading,          // Loading state for Challenge deletion
    postAfterIdeaListRemoveEvalutorIsLoading   // Loading state for Idea deletion
  } = props;

  const [selectedChallengeId, setSelectedChallengeId] = useState('');
  const [mode, setMode] = useState('CHALLENGE'); // 'CHALLENGE' | 'IDEAS'
  const [dataFromChild, setDataFromChild] = useState([]);

  // Reset form states when switching management modes
  useEffect(() => {
    setSelectedChallengeId('');
    setDataFromChild([]);
  }, [mode]);

  // Fetch linked ideas when a specific challenge is focused in IDEAS mode
  useEffect(() => {
    const payloadIdeaList = {
      challengeKey: selectedChallengeId,
      userEmail
    };

    if (mode === 'IDEAS' && selectedChallengeId && getIdeaListFromChallengeFn) {
      getIdeaListFromChallengeFn(payloadIdeaList);
    }
  }, [selectedChallengeId, userEmail, mode, getIdeaListFromChallengeFn]);

  const handleChallengeSubmit = () => {
    const payloadPass = {
      challengeKeyStr: dataFromChild,
      challengeKeyList: dataFromChild,
      userEmail
    };
    if (deleteAssignedEvaluatorIntoChallengeFn) {
      deleteAssignedEvaluatorIntoChallengeFn(payloadPass);
    }
    
    // setSelectedChallengeId('');
    // setDataFromChild([]);
  };

  const handleChildData = (childObject) => {
    setDataFromChild(childObject);
  };

  const handleSpecificIdeaChallengeSubmit = () => {
    
    const payloadPass = {
      challengeKey: selectedChallengeId,
      ideaKeys: dataFromChild,
      ideaKeysList: dataFromChild,
      userEmail
    };
    
    if (onDeteleSpecificIdeaListFromChallengeFn) {
      onDeteleSpecificIdeaListFromChallengeFn(payloadPass);
    }

  };

  if (challengesListIsLoading) {
    return <Loading />;
  }

  return (
    <div className={classes.containerEvaluator}>
      <div className={classes.card}>
        <h2 className={classes.cardTitle}>
          Manage Evaluation Task{' '}
          <span className="icon-info tooltip_v">
            <span 
              title="This feature allows administrators to manage or remove Idea evaluators who are still pending for the selected challenge." 
              className="tooltiptext_v"
            >
              This feature allows administrators to manage or remove Idea evaluators who are still pending for the selected challenge.
            </span>
          </span>
        </h2>

        <ModeToggle mode={mode} onChange={setMode} />

        {/* CHALLENGE MODE */}
        {mode === 'CHALLENGE' && (
          <div className={`auth-form1 ${classes.formSection}`}>
            <p className={classes.label}><b>Select Challenges to Remove Evaluators</b></p>
            <IdeaDropdownWithSearch
              dataList={listInnovateChallengeForEvalutor || []}
              sendDataToParent={handleChildData}
              mode="CHALLENGE"
            />
            <button
              type="button"
              className="auth-button primary"
              onClick={handleChallengeSubmit}
              disabled={postAfterRemoveEvalutorIsLoading || !dataFromChild?.length}
            >
              {postAfterRemoveEvalutorIsLoading ? 'Removing...' : 'Remove Evaluators From Challenges'}
            </button>
          </div>
        )}

        {/* IDEAS MODE */}
        {mode === 'IDEAS' && (
          <div className={`auth-form1 ${classes.formSection}`}>
            <p className={classes.label}><b>Select a challenge</b></p>
            <ChallengeSelect
              challenges={listInnovateChallengeForEvalutor?.data || listInnovateChallengeForEvalutor || []}
              value={selectedChallengeId}
              onChange={setSelectedChallengeId}
              loading={challengesListIsLoading}
            />

            {selectedChallengeId && (
              <>
                <p className={classes.label}><b>Select Specific Ideas to Clear Evaluators</b></p>
                <NxtCircularLoader isLoading={getListIdeaListRemoveEvalutorIsLoading }>
                  <IdeaDropdownWithSearch
                    dataList={getInnovateIdeaListFromChallenge || []}
                    sendDataToParent={handleChildData}
                    mode="IDEAS"
                  />
                </NxtCircularLoader>
                
                <button
                  type="button"
                  className="auth-button primary"
                  onClick={handleSpecificIdeaChallengeSubmit}
                  disabled={postAfterIdeaListRemoveEvalutorIsLoading || !dataFromChild?.length}
                >
                  {postAfterIdeaListRemoveEvalutorIsLoading ? 'Removing...' : 'Remove Evaluators From Selected Ideas'}
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminRemoveEvaluator;
